var isSVGTag = function isSVGTag(tag) {
  return typeof tag === "string" && tag.toLowerCase() === "svg";
};

export { isSVGTag };